import { inject } from '@angular/core';
import { Router, CanActivateFn, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { isOfficeEnvironment, OFFICE_ALLOWED_ROUTES } from 'ngx-q360-lib';

export const officeRouteGuard: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const router = inject(Router);

  if (!isOfficeEnvironment()) {
    return true;
  }

  const isAllowed = OFFICE_ALLOWED_ROUTES.some((allowed) => state.url.startsWith(allowed));
  if (!isAllowed) {
    return router.createUrlTree(['/office/my-work-kan-ban']);
  }

  return true;
};
